








































































































































import Vue from "vue"
import {mapMutations, mapActions, mapState} from "vuex"
import scrumbs from "@/components/navigation/Scrumbs.vue"
export default Vue.extend({
  name: "home",

  components:{
    scrumbs,
  },

  data: () => ({
    fab: false
  }),

  methods: {
    to_top(){
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  }
});
